
const Index = () => import(/* webpackChunkName: "global" */ './index.vue');
const List = () => import(/* webpackChunkName: "global" */ './components/List.vue');

export default [
  {
    path: '/comment',
    name: 'comment',
    component: Index,
    title: 'Comment',
    redirect: { name: 'comment-list' },
    children: [
      {
        path: 'dashboard',
        name: 'comment-list',
        component: List,
      },
    ],
  },
]
